// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// import wx from 'weixin-js-sdk'
// Vue.prototype.wx = wx;

import ajax from "@/basic/ajax"
Vue.prototype.ajax = ajax;

import publics from '@/basic/publics'
Vue.prototype.publics = publics


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js